var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRouletteWheelBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x2014_\\xCE\\xD3\\xC8_x5F_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 629.25 629.25",
    style: {
      enableBackground: "new 0 0 629.25 629.25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FFE94D;}\n\t.st2{fill:#FFC3E0;}\n\t.st3{fill:#E72E5C;}\n\t.st4{fill:#FFDA3E;}\n\t.st5{fill:#1DB3DB;}\n\t.st6{fill:#E0D5B3;}\n\t.st7{fill:#871233;}\n\t.st8{fill:#FFEA6C;}\n\t.st9{fill:#EFE8CE;}\n\t.st10{fill:#FFED10;}\n\t.st11{fill:none;stroke:#E72E5C;stroke-width:8;stroke-miterlimit:10;}\n\t.st12{fill:#FFB8D3;}\n\t.st13{fill:none;stroke:#E0D5B3;stroke-width:6;stroke-miterlimit:10;}\n\t.st14{fill:none;stroke:#E72E5C;stroke-width:5;stroke-miterlimit:10;}\n\t.st15{clip-path:url(#SVGID_00000044176888814957311260000004772340176791010701_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 341.41,
    cy: 32.79,
    r: 13.49
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.83,500.6c-0.46-0.62-0.93-1.23-1.39-1.85C67.9,499.37,68.37,499.99,68.83,500.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.29,533.29c-0.2-0.2-0.4-0.4-0.59-0.59C96.89,532.89,97.09,533.09,97.29,533.29z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.76,505.71c-0.19-0.24-0.37-0.48-0.56-0.71C72.39,505.23,72.57,505.47,72.76,505.71z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "314.88,315.19 314.88,315.2 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "314.88,315.19 314.88,315.2 314.88,315.2 314.88,315.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M532.54,97.16c0.14,0.14,0.29,0.29,0.44,0.44C532.83,97.46,532.69,97.31,532.54,97.16z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "314.88,315.2 314.88,315.2 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351.98,9.34c1.19,0.14,2.38,0.28,3.54,0.44C354.35,9.63,353.16,9.49,351.98,9.34z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.52,72.95c0.16-0.13,0.32-0.25,0.49-0.38C124.84,72.7,124.68,72.82,124.52,72.95z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.64,69.01c0.64-0.48,1.28-0.97,1.92-1.44C130.92,68.05,130.28,68.53,129.64,69.01z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M346.18,8.69c0.21,0.02,0.41,0.04,0.62,0.07C346.6,8.73,346.39,8.71,346.18,8.69z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.8,60.33c-1.14,0.78-2.29,1.56-3.42,2.35C139.53,61.88,140.67,61.1,141.8,60.33z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.38,62.69c-1.36,0.95-2.74,1.93-4.12,2.93C135.62,64.63,137,63.65,138.38,62.69z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.69,492.15c0.95,1.36,1.93,2.72,2.92,4.1C64.63,494.89,63.66,493.52,62.69,492.15z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.59,10.67c-1.57-0.24-3.16-0.48-4.77-0.7C358.41,10.18,360,10.42,361.59,10.67z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M476.17,52.69c-1.55-0.95-3.1-1.89-4.67-2.82C473.08,50.81,474.64,51.74,476.17,52.69z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M370.36,12.15c-1.38-0.25-2.76-0.5-4.15-0.73C367.61,11.65,369,11.89,370.36,12.15z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M370.39,12.15c-0.01,0-0.02,0-0.02,0C370.37,12.15,370.38,12.15,370.39,12.15z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M366.21,11.42c-1.52-0.26-3.06-0.51-4.63-0.75C363.14,10.9,364.68,11.16,366.21,11.42z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M485,58.35c-0.64-0.43-1.28-0.85-1.93-1.27C483.72,57.5,484.36,57.92,485,58.35z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M483.07,57.08c-2.1-1.38-4.25-2.75-6.48-4.13C478.77,54.29,480.93,55.68,483.07,57.08z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M485,58.35c0.35,0.23,0.69,0.47,1.04,0.71c0-0.01,0.01-0.01,0.01-0.02C485.71,58.81,485.35,58.58,485,58.35 z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M470.93,49.53c-1.65-0.97-3.31-1.93-4.98-2.87C467.64,47.61,469.3,48.57,470.93,49.53z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M617.77,371.52c-0.18,0.97-0.37,1.94-0.56,2.91c0,0,0,0,0,0C617.4,373.48,617.59,372.5,617.77,371.52z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M574.85,480.54c-0.22,0.35-0.44,0.67-0.66,1.02C574.4,481.22,574.63,480.88,574.85,480.54L574.85,480.54z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M574.18,481.56c-0.81,1.27-1.64,2.52-2.47,3.77c0,0,0.01,0.01,0.01,0.01 C572.54,484.11,573.36,482.83,574.18,481.56z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M158.35,580.57c-1.64-0.97-3.26-1.95-4.84-2.92C155.11,578.64,156.72,579.61,158.35,580.57 C158.35,580.57,158.35,580.57,158.35,580.57z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M146.86,573.42c2.09,1.37,4.23,2.74,6.44,4.11C151.13,576.18,148.99,574.81,146.86,573.42z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M146.86,573.42c-0.7-0.46-1.4-0.91-2.09-1.37C145.46,572.5,146.16,572.96,146.86,573.42z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M143.71,571.35c0.34,0.23,0.71,0.46,1.06,0.7c-0.35-0.23-0.7-0.48-1.05-0.71 C143.72,571.34,143.72,571.34,143.71,571.35z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M168.2,586.15c0.43,0.23,0.86,0.45,1.29,0.68C169.07,586.61,168.64,586.38,168.2,586.15 C168.21,586.15,168.21,586.15,168.2,586.15z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M259.28,618.22c0.07,0.01,0.14,0.03,0.21,0.04C259.43,618.25,259.35,618.23,259.28,618.22z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M259.5,618.26c1.14,0.21,2.29,0.41,3.43,0.61C261.77,618.67,260.63,618.47,259.5,618.26z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M262.93,618.87c1.77,0.3,3.56,0.6,5.39,0.88C266.51,619.47,264.72,619.17,262.93,618.87z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M268.32,619.75c1.57,0.24,3.16,0.48,4.77,0.7C271.49,620.23,269.9,619.99,268.32,619.75z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M500.1,561.39c-0.63,0.47-1.26,0.95-1.88,1.41C498.85,562.33,499.48,561.86,500.1,561.39z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M491.36,567.72c1.36-0.95,2.74-1.93,4.12-2.93C494.12,565.78,492.74,566.75,491.36,567.72z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M488.01,570.02c1.12-0.76,2.24-1.53,3.35-2.3C490.24,568.51,489.12,569.27,488.01,570.02z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M505.23,557.45c-0.15,0.11-0.29,0.23-0.44,0.34C504.94,557.68,505.08,557.57,505.23,557.45z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M532.79,532.98c-0.07,0.07-0.14,0.14-0.21,0.21C532.65,533.11,532.72,533.04,532.79,532.98z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M277.85,621.05c-1.22-0.15-2.45-0.29-3.66-0.46C275.41,620.76,276.63,620.91,277.85,621.05z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283.62,621.71c-0.25-0.03-0.49-0.05-0.74-0.08C283.13,621.65,283.37,621.68,283.62,621.71z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M349.67,9.06c-0.97-0.11-1.92-0.21-2.87-0.3c1.73,0.18,3.46,0.39,5.18,0.59 C351.21,9.25,350.46,9.15,349.67,9.06z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M355.52,9.78c0.43,0.06,0.86,0.12,1.29,0.18C356.38,9.91,355.96,9.84,355.52,9.78z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M555.38,122.61c-7.58-9.48-15.17-17.77-22.41-25.01c8.55,8.57,16.59,17.64,24.09,27.16 C556.51,124.04,555.96,123.33,555.38,122.61z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M532.08,96.7C532.08,96.7,532.08,96.71,532.08,96.7c0.15,0.16,0.31,0.31,0.46,0.46 C532.39,97.01,532.23,96.85,532.08,96.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.2 314.88,315.2 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.2 314.88,315.2 314.88,315.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M125.01,72.57c1.53-1.2,3.08-2.38,4.64-3.56C128.11,70.17,126.56,71.35,125.01,72.57z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M122.94,74.18c-9.78,7.78-18.31,15.57-25.71,22.98c8.61-8.59,17.72-16.68,27.3-24.21 C123.99,73.36,123.47,73.76,122.94,74.18z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M131.57,67.58c0.89-0.66,1.79-1.31,2.69-1.96C133.36,66.26,132.47,66.91,131.57,67.58z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.2 314.88,315.2 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M280.09,621.33c0.94,0.11,1.86,0.2,2.79,0.3c-1.68-0.17-3.36-0.37-5.03-0.57 C278.6,621.14,279.33,621.25,280.09,621.33z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M314.81,623.28c-10.53,0-20.93-0.53-31.19-1.57C294.81,622.85,305.26,623.29,314.81,623.28z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M274.2,620.6c-0.37-0.05-0.74-0.1-1.11-0.15C273.46,620.49,273.82,620.55,274.2,620.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.2 314.88,315.2 314.88,315.2  314.88,315.2 314.88,315.2 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.2 314.88,315.2 314.88,315.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.2 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.2 314.88,315.2 314.88,315.2 314.88,315.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M67.45,498.76c-0.62-0.83-1.22-1.67-1.83-2.51C66.22,497.08,66.82,497.92,67.45,498.76z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M74.38,507.78c7.55,9.44,15.1,17.7,22.32,24.92c-8.49-8.52-16.49-17.53-23.94-26.99 C73.3,506.4,73.83,507.09,74.38,507.78z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M72.2,505c-1.14-1.45-2.26-2.92-3.37-4.39C69.93,502.06,71.05,503.52,72.2,505z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M97.69,533.69C97.69,533.68,97.69,533.68,97.69,533.69c-0.13-0.14-0.26-0.27-0.4-0.4 C97.42,533.42,97.55,533.56,97.69,533.69z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.2 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.89,315.19 314.88,315.19  314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.2 314.88,315.2 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "532.8,532.97 532.8,532.97 532.79,532.98  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M504.79,557.79c-1.55,1.21-3.11,2.41-4.69,3.59C501.66,560.22,503.22,559.02,504.79,557.79z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M506.83,556.21c9.8-7.8,18.35-15.6,25.76-23.03c-8.63,8.62-17.76,16.72-27.36,24.27 C505.76,557.03,506.29,556.63,506.83,556.21z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M498.22,562.8c-0.91,0.67-1.82,1.33-2.74,2C496.39,564.14,497.3,563.47,498.22,562.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.2 314.89,315.2 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.2 314.88,315.2 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.2 314.88,315.2 314.88,315.2 314.88,315.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.2 314.88,315.2 314.88,315.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.2 314.88,315.2 314.88,315.2 314.88,315.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.2 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.2 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.2 314.88,315.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.2 314.88,315.2 314.88,315.2 314.88,315.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.2 314.88,315.2 314.88,315.2 314.88,315.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.2 314.88,315.2 314.88,315.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.2 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.2 314.88,315.2 314.88,315.2 314.88,315.2 314.88,315.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.2 314.88,315.2 314.89,315.2 314.89,315.2 314.88,315.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.2 314.88,315.2 314.88,315.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M314.92,33.53c-162.32,0-293.9,131.58-293.9,293.9s131.58,293.9,293.9,293.9 c162.32,0,293.9-131.58,293.9-293.9S477.24,33.53,314.92,33.53z M314.5,584.39c-141.61,0-256.41-114.8-256.41-256.41 S172.89,71.58,314.5,71.58s256.41,114.8,256.41,256.41S456.11,584.39,314.5,584.39z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19 314.88,315.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M314.63,5.97C144.16,5.97,5.97,144.16,5.97,314.62s138.19,308.65,308.65,308.65s308.65-138.19,308.65-308.65 S485.09,5.97,314.63,5.97z M314.18,584.48c-148.72,0-269.27-120.56-269.27-269.27S165.47,45.93,314.18,45.93 s269.27,120.56,269.27,269.27S462.9,584.48,314.18,584.48z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M314.88,7.11c10.57,0,21.01,0.53,31.3,1.57C334.95,7.54,324.46,7.09,314.88,7.11z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M582.15,415.48c-0.05,0.08-0.09,0.16-0.13,0.24c0.1-0.1-0.22,0.79-0.39,1.38c0.16-0.28,0.07,2.2-0.04,0.92 c0.02,0.21,0.03,0.66,0.03,0.86c0-0.09,0-0.23,0-0.45c0,0.02,0.04,0.19,0.09,0.37c0.12,0.14,0.35,0.35,0.46,0.45 c0.01,0.01,0.03,0.01,0.04,0.02c0.28-1.14,0.55-2.29,0.81-3.44C582.72,415.75,582.43,415.63,582.15,415.48z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M314.63,629.25c-84.04,0-163.05-32.73-222.47-92.15C32.73,477.67,0,398.66,0,314.62 S32.73,151.58,92.15,92.15C151.58,32.73,230.59,0,314.63,0S477.67,32.73,537.1,92.15c59.42,59.42,92.15,138.43,92.15,222.47 S596.52,477.67,537.1,537.1C477.67,596.52,398.66,629.25,314.63,629.25z M314.63,11.95c-166.9,0-302.68,135.78-302.68,302.68 S147.73,617.3,314.63,617.3S617.3,481.52,617.3,314.62S481.52,11.95,314.63,11.95z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M314.18,590.45c-73.52,0-142.64-28.63-194.63-80.62C67.57,457.85,38.93,388.73,38.93,315.2 c0-73.52,28.63-142.64,80.62-194.63c51.99-51.99,121.11-80.62,194.63-80.62c73.52,0,142.64,28.63,194.63,80.62 c51.99,51.99,80.62,121.11,80.62,194.63c0,73.52-28.63,142.64-80.62,194.63C456.82,561.82,387.7,590.45,314.18,590.45z  M314.18,51.9C169,51.9,50.88,170.02,50.88,315.2s118.12,263.3,263.3,263.3s263.3-118.12,263.3-263.3S459.37,51.9,314.18,51.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 516.38,
    cy: 108.31,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 90.9596 313.2934)",
    className: "st10",
    cx: 423.66,
    cy: 46.85,
    rx: 8.07,
    ry: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 577.02,
    cy: 197.4,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 601.44,
    cy: 308.46,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 582.87,
    cy: 416.48,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2298 -0.9732 0.9732 0.2298 -96.1826 905.8735)",
    className: "st10",
    cx: 524.22,
    cy: 513.7,
    rx: 8.07,
    ry: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 425.83,
    cy: 580.65,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 313.15,
    cy: 604.16,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 205.32,
    cy: 580.65,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 112.91,
    cy: 521.77,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 47.53,
    cy: 425.89,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 25.04,
    cy: 312.25,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.229 -0.9734 0.9734 0.229 -163.5408 202.8931)",
    className: "st10",
    cx: 46.31,
    cy: 204.68,
    rx: 8.07,
    ry: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 111.03,
    cy: 108.58,
    r: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2298 -0.9732 0.9732 0.2298 113.0212 236.5062)",
    className: "st10",
    cx: 205.93,
    cy: 46.85,
    rx: 8.07,
    ry: 8.07
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 321.22,
    cy: 24.7,
    r: 8.07
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouletteWheelBorder);
export default __webpack_public_path__ + "static/media/roulette-wheel-border.df60e4b55c16b93d5960d8afd6eccf68.svg";
export { ForwardRef as ReactComponent };